$(document).ready(function() {
  windowHeight();
  navMenuView();
});

$(window).resize( function(){
  windowHeight();
  navMenuView();
});

function navMenuView(){
  if( !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) ) {
    $( '.o-grid__item').hide();
  }else{
    if ( $(window).width() <= 1024 ){
      $( '.o-grid__item').show();
    }else{
      $( '.o-grid__item').hide();
    }
  }
}

(function() {

    "use strict";

    var toggles = document.querySelectorAll(".nav-menu");

    for (var i = toggles.length - 1; i >= 0; i--) {
      var toggle = toggles[i];
      toggleHandler(toggle);
    };

    function toggleHandler(toggle) {
      toggle.addEventListener( "click", function(e) {
        e.preventDefault();
        if (this.classList.contains("is-active") === true){


          // $('html').css('overflow', 'scroll');

          document.ontouchmove = function(e){ return true; }

          TweenMax.staggerTo( "nav li", 0.5, {

            x:100,
            opacity: 0,
            ease:Back.easeIn
          }, 0.1, closeMenu );

          this.classList.remove("is-active");


        }else{

          this.classList.add("is-active");

          // $('html').css('overflow', 'hidden');

          document.ontouchmove = function(event){
            event.preventDefault();
          }
          openMenu();

          TweenMax.staggerTo( "nav li", 0.5, {
            x:0,
            opacity: 1,
            ease:Back.easeOut
          }, 0.1 );

        }

      });
    }

  })();

  //remove menu when I click into a menu voice
  $( 'nav li').bind( 'touchstart click' , function(){
    $('html').css('overflow', 'scroll');

    document.ontouchmove = function(e){ return true; }

    TweenMax.staggerTo( "nav li", 0.5, {

      x:100,
      opacity: 0,
      ease:Back.easeIn
    }, 0.1, closeMenu );

    $(".nav-menu").removeClass("is-active");


  });


  function closeMenu(){
    $("nav").stop(true,true).fadeOut('slow');
  }

  function openMenu(){
    $("nav").stop(true,true).fadeIn();
  }

  function windowHeight(){
    var navHeight = 500;
    if ( $(window).height() <= navHeight) {
      $('nav li').css('display', 'inline-block');
      $('nav ul').addClass('nav-menu__inline');
    }else{
      $('nav li').css('display', 'block');
      $('nav ul').removeClass('nav-menu__inline');
    }
  }



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/nav-menu.js
 ** module id = 149
 ** module chunks = 0
 **/